// Set User ID for tracking
import { getTrackingInstance, isTrackingInitialized } from './initTracking';

// Set the user ID for tracking - call after login
export const setUserId = (userId: string | undefined): void => {
  if (!isTrackingInitialized()) return;

  const instance = getTrackingInstance();
  if (!instance) return;

  instance.setUserId(userId);
};
